import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kui soovid ostmise osas veel järele mõelda, aga soovid tooteid meeles hoida, siis vajuta lemmikuks lisamine nuppu.

  <span style="color:#85c1dc;">**FI:**</span>
  Jos haluat vielä harkita ostoa, mutta haluat pitää tuotteet mielessä, paina lisää suosikkeihin -painiketta.

  <span style="color:#85c1dc;">**RU:**</span>
  Если Вы ещё хотите подумать о покупке, но хотите запомнить товары, нажмите кнопку добавить в избранное.
*/
/* @__NO_SIDE_EFFECTS__ */
const m1602 = msg(
  mf`Kui soovid ostmise osas veel järele mõelda, aga soovid tooteid meeles hoida, siis vajuta lemmikuks lisamine nuppu.`,
  mf`Jos haluat vielä harkita ostoa, mutta haluat pitää tuotteet mielessä, paina lisää suosikkeihin -painiketta.`,
  mf`Если Вы ещё хотите подумать о покупке, но хотите запомнить товары, нажмите кнопку добавить в избранное.`,
)

export { m1602 as 'w.wishlist.empty_wishlist_text' }